// Central API base configuration for the clinic frontend
import appConfig from '../config/appConfig';

const API_BASE = appConfig.apiBase;

export default API_BASE;
